import { withDisplayName } from '@hocs/with-display-name'
import { Tag } from '@ui/atoms/tag'
import { graphql, Link as GatsbyLink } from 'gatsby'
import React from 'react'

const ContentfulFaqSubCategoryPageClickableChip: Utils.EntryFC<
  Queries.ContentfulFaqSubCategoryPageClickableChipFragment
> = ({ content: { title, href }, entryInspectorProps }) => (
  <Tag as={GatsbyLink} to={href} {...entryInspectorProps()}>
    {title}
  </Tag>
)

export const query = graphql`
  fragment ContentfulFaqSubCategoryPageClickableChip on ContentfulFaqSubCategoryPage {
    ...ContentfulEntry
    title
    href: getHref
  }
`

export default withDisplayName(
  ContentfulFaqSubCategoryPageClickableChip,
  'ContentfulFaqSubCategoryPageClickableChip'
)
